import { createContext, useContext, useEffect, useState } from "react";

const STRINGS = {
  en: {
    nav_super_admin: "Super-Admin",
    nav_clinic_admin: "Clinic-Admin",
    nav_logout: "Logout",
    login_title: "Sign in",
    login_subtitle: "Role-based access for clinics and patients.",
    login_email: "Email",
    login_password: "Password",
    login_submit: "Sign in",
    login_quick: "Quick demo accounts",
    login_new_clinic: "New clinic?",
    login_new_clinic_sub: "List your clinic. Get a payment QR. Go live in minutes.",
    login_new_clinic_cta: "List my clinic →",
    dash_global_overview: "Global Overview",
    dash_global_sub: "All clinics, all patients, one pulse.",
    dash_add_clinic: "Add Clinic",
    dash_hi: "Hi",
    dash_pulse: "here's your pulse.",
    dash_refresh: "Refresh",
    kpi_revenue: "Revenue Recovered",
    kpi_time: "Time Saved",
    kpi_overdue: "Overdue",
    kpi_today: "Today's Appointments",
    kpi_invoices: "{n} invoices recovered",
    kpi_triage_scribe: "Triage + scribe automation",
    kpi_pending: "{n} invoices pending",
    tab_overview: "Overview",
    tab_recovery: "Revenue Recovery",
    tab_ledger: "Payment Ledger",
    tab_whatsapp: "WhatsApp",
    tab_appointments: "Appointments",
    tab_voice: "Voice-to-EMR",
    tab_voicenotes: "Voice Notes",
    tab_triage: "Triage Sessions",
    tab_clinics: "Tenant Clinics",
    tab_requests: "Signup Requests",
    tab_emails: "Email Templates",
    tab_announcements: "Announcements",
    btn_run_recovery: "Run Recovery Now",
    btn_listen: "Listen",
    btn_record: "Tap to record",
    btn_recording: "Recording",
    btn_transcribing: "Transcribing…",
    btn_generate_note: "Generate Structured Note",
    btn_send_wa: "WhatsApp",
    btn_pdf: "PDF",
    btn_close: "Close",
    btn_send: "Send",
    btn_convert_note: "Convert to Clinical Note",
    triage_full_chat: "Triage Conversation",
    triage_reply_placeholder: "Type a reply to the patient…",
    triage_summary: "AI Summary",
    triage_no_phone: "no phone",
    lang_switch: "Language",
    sa_total_patients: "Total Patients",
    sa_platform_users: "platform users",
    sa_tenant_network: "Tenant network",
    sa_triage_sessions: "triage sessions",
    sa_tenants_count: "{n} tenants",
    sa_tenant_clinics_sub: "Toggle access. View per-clinic recovery.",
    th_clinic: "Clinic",
    th_patients: "Patients",
    th_revenue_recovered: "Revenue Recovered",
    th_status: "Status",
    th_access: "Access",
    status_active: "Active",
    status_paused: "Paused",
  },
  hi: {
    nav_super_admin: "सुपर-एडमिन",
    nav_clinic_admin: "क्लिनिक-एडमिन",
    nav_logout: "लॉगआउट",
    login_title: "साइन इन",
    login_subtitle: "क्लिनिक और मरीज़ों के लिए भूमिका-आधारित पहुँच।",
    login_email: "ईमेल",
    login_password: "पासवर्ड",
    login_submit: "साइन इन करें",
    login_quick: "त्वरित डेमो खाते",
    login_new_clinic: "नई क्लिनिक?",
    login_new_clinic_sub: "अपनी क्लिनिक सूचीबद्ध करें। भुगतान क्यूआर पाएं। मिनटों में शुरू हो जाएं।",
    login_new_clinic_cta: "मेरी क्लिनिक सूचीबद्ध करें →",
    dash_global_overview: "ग्लोबल अवलोकन",
    dash_global_sub: "सभी क्लिनिक, सभी मरीज़, एक नब्ज़।",
    dash_add_clinic: "क्लिनिक जोड़ें",
    dash_hi: "नमस्ते",
    dash_pulse: "यहाँ आपकी नब्ज़ है।",
    dash_refresh: "रीफ्रेश",
    kpi_revenue: "वसूली गई आय",
    kpi_time: "समय बचाया",
    kpi_overdue: "बकाया",
    kpi_today: "आज की अपॉइंटमेंट",
    kpi_invoices: "{n} इनवॉइस वसूल की गईं",
    kpi_triage_scribe: "ट्रायेज + स्क्राइब स्वचालन",
    kpi_pending: "{n} इनवॉइस लंबित",
    tab_overview: "अवलोकन",
    tab_recovery: "आय वसूली",
    tab_ledger: "भुगतान खाता",
    tab_whatsapp: "व्हाट्सएप",
    tab_appointments: "अपॉइंटमेंट",
    tab_voice: "वॉयस-टू-EMR",
    tab_voicenotes: "वॉयस नोट्स",
    tab_triage: "ट्रायेज सत्र",
    tab_clinics: "टेनेंट क्लिनिक",
    tab_requests: "साइनअप अनुरोध",
    tab_emails: "ईमेल टेम्पलेट",
    tab_announcements: "घोषणाएं",
    btn_run_recovery: "अभी वसूली चलाएं",
    btn_listen: "सुनें",
    btn_record: "रिकॉर्ड करने के लिए टैप करें",
    btn_recording: "रिकॉर्डिंग",
    btn_transcribing: "ट्रांसक्राइब हो रहा है…",
    btn_generate_note: "संरचित नोट बनाएं",
    btn_send_wa: "व्हाट्सएप",
    btn_pdf: "पीडीएफ",
    btn_close: "बंद करें",
    btn_send: "भेजें",
    btn_convert_note: "क्लिनिकल नोट में बदलें",
    triage_full_chat: "ट्रायेज वार्तालाप",
    triage_reply_placeholder: "मरीज को जवाब लिखें…",
    triage_summary: "AI सारांश",
    triage_no_phone: "कोई फोन नहीं",
    lang_switch: "भाषा",
    sa_total_patients: "कुल मरीज़",
    sa_platform_users: "प्लेटफ़ॉर्म उपयोगकर्ता",
    sa_tenant_network: "टेनेंट नेटवर्क",
    sa_triage_sessions: "ट्रायेज सत्र",
    sa_tenants_count: "{n} टेनेंट",
    sa_tenant_clinics_sub: "एक्सेस टॉगल करें। प्रति-क्लिनिक वसूली देखें।",
    th_clinic: "क्लिनिक",
    th_patients: "मरीज़",
    th_revenue_recovered: "वसूली गई आय",
    th_status: "स्थिति",
    th_access: "एक्सेस",
    status_active: "सक्रिय",
    status_paused: "रोका गया",
  },
  te: {
    nav_super_admin: "సూపర్-అడ్మిన్",
    nav_clinic_admin: "క్లినిక్-అడ్మిన్",
    nav_logout: "లాగ్అవుట్",
    login_title: "సైన్ ఇన్",
    login_subtitle: "క్లినిక్‌లు మరియు రోగుల కోసం పాత్ర ఆధారిత యాక్సెస్.",
    login_email: "ఇమెయిల్",
    login_password: "పాస్‌వర్డ్",
    login_submit: "సైన్ ఇన్ చేయండి",
    login_quick: "శీఘ్ర డెమో ఖాతాలు",
    login_new_clinic: "కొత్త క్లినిక్?",
    login_new_clinic_sub: "మీ క్లినిక్‌ను నమోదు చేయండి. చెల్లింపు QR పొందండి. నిమిషాల్లో ప్రారంభించండి.",
    login_new_clinic_cta: "నా క్లినిక్ నమోదు చేయండి →",
    dash_global_overview: "గ్లోబల్ అవలోకనం",
    dash_global_sub: "అన్ని క్లినిక్‌లు, అన్ని రోగులు, ఒకే పల్స్.",
    dash_add_clinic: "క్లినిక్ జోడించు",
    dash_hi: "హాయ్",
    dash_pulse: "ఇదిగో మీ పల్స్.",
    dash_refresh: "రీఫ్రెష్",
    kpi_revenue: "తిరిగి పొందిన ఆదాయం",
    kpi_time: "ఆదా అయిన సమయం",
    kpi_overdue: "బకాయి",
    kpi_today: "నేటి అపాయింట్‌మెంట్లు",
    kpi_invoices: "{n} ఇన్వాయిస్‌లు తిరిగి పొందబడ్డాయి",
    kpi_triage_scribe: "ట్రయేజ్ + స్క్రైబ్ ఆటోమేషన్",
    kpi_pending: "{n} ఇన్వాయిస్‌లు పెండింగ్",
    tab_overview: "అవలోకనం",
    tab_recovery: "ఆదాయ రికవరీ",
    tab_ledger: "చెల్లింపు లెడ్జర్",
    tab_whatsapp: "వాట్సాప్",
    tab_appointments: "అపాయింట్‌మెంట్లు",
    tab_voice: "వాయిస్-టు-EMR",
    tab_voicenotes: "వాయిస్ నోట్లు",
    tab_triage: "ట్రయేజ్ సెషన్లు",
    tab_clinics: "టెనెంట్ క్లినిక్‌లు",
    tab_requests: "సైన్‌అప్ అభ్యర్థనలు",
    tab_emails: "ఇమెయిల్ టెంప్లేట్‌లు",
    tab_announcements: "ప్రకటనలు",
    btn_run_recovery: "ఇప్పుడే రికవరీ చేయండి",
    btn_listen: "వినండి",
    btn_record: "రికార్డ్ చేయడానికి నొక్కండి",
    btn_recording: "రికార్డింగ్",
    btn_transcribing: "ట్రాన్స్క్రైబ్ చేస్తోంది…",
    btn_generate_note: "నిర్మాణాత్మక నోట్ సృష్టించండి",
    btn_send_wa: "వాట్సాప్",
    btn_pdf: "పీడీఎఫ్",
    btn_close: "మూసివేయి",
    btn_send: "పంపండి",
    btn_convert_note: "క్లినికల్ నోట్‌గా మార్చండి",
    triage_full_chat: "ట్రయేజ్ సంభాషణ",
    triage_reply_placeholder: "రోగికి సమాధానం టైప్ చేయండి…",
    triage_summary: "AI సారాంశం",
    triage_no_phone: "ఫోన్ లేదు",
    lang_switch: "భాష",
  },
};

const I18nCtx = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("pulse_lang") || "en");
  useEffect(() => { localStorage.setItem("pulse_lang", lang); document.documentElement.lang = lang; }, [lang]);
  const t = (key, vars = {}) => {
    const dict = STRINGS[lang] || STRINGS.en;
    let s = dict[key] || STRINGS.en[key] || key;
    Object.keys(vars).forEach((k) => { s = s.replace(`{${k}}`, vars[k]); });
    return s;
  };
  return <I18nCtx.Provider value={{ lang, t, setLang: setLangState }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);

export const LANGS = [
  { code: "en", label: "EN", name: "English" },
  { code: "hi", label: "हिं", name: "हिन्दी" },
  { code: "te", label: "తె", name: "తెలుగు" },
];
